import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getDateFnsLocaleFromAppLocale } from 'helpers/intl-fns';
import { selectLocale } from 'selectors/locale-data';
import { selectIsDesktop } from 'selectors/ui';
import DateControls from 'components/DateControls/DateControls';

const mapStateToProps = (state, ownProps) => {
  const locale = selectLocale(state);
  const dateFnsLocale = getDateFnsLocaleFromAppLocale(locale);
  // eslint-disable-next-line import/no-dynamic-require
  const dateFnsLocaleFile = require(`date-fns/locale/${dateFnsLocale}/index.js`);

  return {
    isDesktop: selectIsDesktop(state),
    dateFnsLocale: dateFnsLocaleFile,
    ...ownProps,
  };
};

const mergeProps = stateProps => {
  const { onChange, ...restStateProps } = stateProps;
  return {
    setDate: date => onChange(date.toISOString()),
    ...restStateProps,
  };
};

export default compose(connect(mapStateToProps, null, mergeProps), injectIntl)(DateControls);
